import { createRouter, createWebHashHistory } from 'vue-router'
import ENV from '@/constants/env'

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes: [
    {
      path: '',
      name: 'Main',
      component: () => import(/* webpackChunkName: "main" */ '../components/pages/main/Main.vue'),
    },
    {
      path: '/sign-out',
      name: 'SignOut',
      component: () => import(/* webpackChunkName: "main" */ '../components/pages/sign-out/SignOut.vue'),
    },
    {
      path: '/find-id',
      name: 'FindId',
      component: () => import(/* webpackChunkName: "main" */ '../components/pages/find-id/FindId.vue'),
    },
    {
      path: '/find-password',
      name: 'FindPassword',
      component: () => import(/* webpackChunkName: "main" */ '../components/pages/find-password/FindPassword.vue'),
    },
    {
      path: '/system',
      name: 'System',
      component: () => import(/* webpackChunkName: "system" */ '../components/pages/system/System.vue'),
    },
    {
      path: '/popups/sso',
      name: 'SingleSignOn',
      component: () => import(/* webpackChunkName: "popups" */ '../components/pages/popups/sso/SingleSignOn.vue'),
    },
    {
      path: '/popups/offer-member-info',
      name: 'OfferMemberInfo',
      component: () => import(/* webpackChunkName: "popups" */ '../components/pages/popups/offer-member-info/OfferMemberInfo.vue'),
    },
    {
      path: '/popups/eop-manual',
      name: 'EopManual',
      component: () => import(/* webpackChunkName: "popups" */ '../components/pages/popups/eop-manual/EopManual.vue'),
    },
  ],
})

router.afterEach((to) => {
  let documentTitle = ''
  switch (ENV) {
    case 'local':
      documentTitle += `💻 `
      break
    case 'dev':
      documentTitle += `🖥️ `
      break
    case 'qa':
      documentTitle += `🧪 `
      break
    case 'uat':
      documentTitle += `🚀 `
      break
  }
  documentTitle += to.meta.title ? `${to.meta.title} - ` : ''
  documentTitle += 'C&S EOP Portal'
  document.title = documentTitle
})

export default router
